import { IHeadCell } from 'components/table/EnhancedTableHead';
import { NoSQLDatabaseItem } from 'models/noSQLDatabases/dto';

const tableConfig: IHeadCell<NoSQLDatabaseItem>[] = [
	{
		id: 'name',
		numeric: false,
		label: 'Name',
		sortable: true,
	},
	{
		id: 'collections_count',
		numeric: true,
		label: 'Collections',
		sortable: true,
	},
	{
		id: 'size',
		numeric: true,
		label: 'Size',
		sortable: true,
	},
	{
		id: 'sensitivity',
		numeric: false,
		label: 'Sensitivity',
		sortable: true,
	},
	{
		id: 'data_types',
		numeric: false,
		label: 'Data types',
		sortable: false,
	},
	{
		id: 'instance_id',
		numeric: false,
		label: 'Instance',
		sortable: false,
	},
	{
		id: 'last_checked',
		numeric: false,
		label: 'Last checked',
		sortable: true,
		reversedSort: true,
	},
];

export default tableConfig;
